__turbopack_context__.v({
  "active": "styles-module__eFJHGG__active",
  "container": "styles-module__eFJHGG__container",
  "divider": "styles-module__eFJHGG__divider",
  "menu": "styles-module__eFJHGG__menu",
  "socials": "styles-module__eFJHGG__socials",
});
